const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  const iconWidth = 35;
  const iconRatio = 0.875;

  return {
    playerIconContainer: props => ({
      position: 'relative',
      display: 'inline-block',
      width: props.iconWidthPx || iconWidth,
      height: props.iconWidthPx || iconWidth,
    }),
    playerIcon: {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
      boxShadow: '1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      filter:
        'drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.25)) drop-shadow(-5px -5px 10px rgba(255, 255, 255, 0.05))',
    },
    playerIconSelected: {
      extend: 'playerIcon',
      background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
    },
    playerIconInner: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%), #202633',
      boxShadow: '1px 1px 1px 0px rgba(0, 0, 0, 0.10) inset',
      borderRadius: '50%',
      width: `${iconRatio * 100}%`,
      height: `${iconRatio * 100}%`,
    },
    playerAvatar: props => {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: `100%`,
        transform: 'translate(-50%, -50%)',
        '& img': {
          borderRadius: '50%',
          objectFit: 'cover',
          width: '100%',
          height: '100%',
          verticalAlign: 'top',
        },
      };
    },
    playerAvatarBorder: props => ({
      fontSize: props.iconWidthPx || iconWidth,
      '& image': {
        height: '100%',
        width: '100%',
      },
    }),
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
